import React from "react";

import MetresField from "../../../CoreComponents/MetresField";

function RadiusField({ value, onChange }) {
  return (
    <MetresField
      id="restaurant-radius"
      label="Delivery radius (metres)"
      hint="In metres, e.g. 5000 for 5 km. Leave 0 to use the franchise's delivery radius. A restaurant can deliver less far than its franchise, never further."
      value={value}
      onChange={onChange}
    />
  );
}

export default RadiusField;
